import { Bold, Code, Italic, Link2, Strikethrough } from "lucide-react";

// Negrito, itálico, riscado, monoespaçado e link.
//
// A marcação do WhatsApp é a mesma do texto: `*negrito*`, `_itálico_`,
// `~riscado~`. Quem sabe, digita; quem não sabe, nunca descobriu que dava —
// e mandava tudo em texto corrido. Os botões escrevem a marcação por quem não
// quer decorar.
//
// A conversa já desenha essas marcas (MarkdownWrapper), então nada muda no
// envio: o que sai é texto, exatamente como antes.
const MARCAS = [
	{ chave: "negrito", marca: "*", icone: Bold, rotulo: "Negrito (Ctrl+B)" },
	{ chave: "italico", marca: "_", icone: Italic, rotulo: "Itálico (Ctrl+I)" },
	{
		chave: "riscado",
		marca: "~",
		icone: Strikethrough,
		rotulo: "Riscado",
	},
	{ chave: "mono", marca: "```", icone: Code, rotulo: "Monoespaçado" },
];

// Envolve a seleção com a marca; sem seleção, deixa o cursor no meio das duas.
export const aplicarMarca = (campo, texto, marca, aoMudar) => {
	if (!campo) return;

	const inicio = campo.selectionStart ?? texto.length;
	const fim = campo.selectionEnd ?? texto.length;
	const escolhido = texto.slice(inicio, fim);

	const novo =
		texto.slice(0, inicio) +
		marca +
		escolhido +
		marca +
		texto.slice(fim);

	aoMudar(novo);

	// O foco volta para o campo com o cursor onde a pessoa espera continuar
	// digitando — senão o clique no botão parece "roubar" a escrita.
	requestAnimationFrame(() => {
		campo.focus();
		const posicao = escolhido
			? fim + marca.length * 2
			: inicio + marca.length;
		campo.setSelectionRange(posicao, posicao);
	});
};

const BarraDeFormatacao = ({ campoRef, texto, aoMudar, desabilitado }) => {
	const inserirLink = () => {
		const campo = campoRef.current;
		if (!campo) return;

		const inicio = campo.selectionStart ?? texto.length;
		const fim = campo.selectionEnd ?? texto.length;
		const escolhido = texto.slice(inicio, fim);

		const url = window.prompt("Endereço do link (https://…)", "https://");

		if (!url || url === "https://") return;

		const trecho = escolhido ? `${escolhido} (${url})` : url;
		const novo = texto.slice(0, inicio) + trecho + texto.slice(fim);

		aoMudar(novo);

		requestAnimationFrame(() => {
			campo.focus();
			const posicao = inicio + trecho.length;
			campo.setSelectionRange(posicao, posicao);
		});
	};

	return (
		<div className="flex items-center gap-0.5 px-3 pb-1">
			{MARCAS.map(({ chave, marca, icone: Icone, rotulo }) => (
				<button
					key={chave}
					type="button"
					title={rotulo}
					aria-label={rotulo}
					disabled={desabilitado}
					onClick={() =>
						aplicarMarca(campoRef.current, texto, marca, aoMudar)
					}
					className="flex h-7 w-7 items-center justify-center rounded text-muted-foreground hover:bg-muted hover:text-foreground disabled:opacity-50"
				>
					<Icone className="h-3.5 w-3.5" />
				</button>
			))}

			<button
				type="button"
				title="Inserir link"
				aria-label="Inserir link"
				disabled={desabilitado}
				onClick={inserirLink}
				className="flex h-7 w-7 items-center justify-center rounded text-muted-foreground hover:bg-muted hover:text-foreground disabled:opacity-50"
			>
				<Link2 className="h-3.5 w-3.5" />
			</button>

			<span className="ml-1 text-[10px] text-muted-foreground">
				*negrito*  _itálico_  ~riscado~
			</span>
		</div>
	);
};

export default BarraDeFormatacao;
